import { useMemo, useState } from 'react';
import { Box, Container, Grid, Typography, ButtonBase, Stack, Button } from '@mui/material';
import CtaFormDialog from '../common/CtaFormDialog';
import { BRAND } from '../../theme/palette';

// Shape reused from references/ProdWebsite/frontend/src/components/impactSection/impactTabs.js.
// Copy is from New Website.docx, homepage tab #1-#3.
const TABS = {
  platform: {
    buttonLabel: 'Our Platform',
    heading: 'Built for certainty at every step of the loan lifecycle',
    body:
      'Our correspondent division funds loans with discipline and precision; supported by the scale, capital strength, and infrastructure of Jet HomeLoans (Jet HL) following our acquisition. The result is a platform that delivers dependable outcomes without sacrificing speed or service.',
    ctaLabel: 'Partner with Us',
  },
  solutions: {
    buttonLabel: 'Lending Solutions',
    heading: 'Mortgage financing designed around real people and real lives',
    body:
      "As a correspondent lending company, we manage loans with efficiency and care. Backed by the scale and strength of Jet HomeLoans (Jet HL) following our acquisition, we deliver consistent approvals, competitive execution, and trusted service; all without losing the local expertise Cherry Creek is known for. Our loans don't just fund homes, they support everyday life, milestones, and the moments that matter most.",
    ctaLabel: 'Get Started',
  },
  partner: {
    buttonLabel: 'Partner Platform',
    heading: 'A relationship driven approach to lending done together',
    body:
      'Cherry Creek Mortgage, LLC (CCM LLC) provides correspondent lenders with a reliable outlet for selling closed loans, delivering compliant processes, consistent execution, and confidence from purchase through settlement.',
    ctaLabel: 'Contact Us',
  },
};

const TAB_ORDER = ['platform', 'solutions', 'partner'];

function TabButton({ active, onClick, children }) {
  return (
    <ButtonBase
      focusRipple
      onClick={onClick}
      sx={{
        px: 3,
        py: 2,
        borderRadius: 0,
        bgcolor: active ? BRAND.tabActiveBg : '#ffffff',
        color: active ? '#fff' : BRAND.tabActiveBg,
        fontWeight: 600,
        letterSpacing: 1,
        fontSize: 13,
        border: '1px solid #e7eaee',
        '&:hover': { bgcolor: active ? BRAND.tabActiveBgHover : '#f7f9fb' },
        transition: 'background-color .2s ease',
      }}
    >
      {children}
    </ButtonBase>
  );
}

export default function PlatformTabsSection() {
  const [active, setActive] = useState('platform');
  const [dialogOpen, setDialogOpen] = useState(false);
  const tab = useMemo(() => TABS[active], [active]);

  return (
    <Box sx={{ bgcolor: BRAND.tabsSectionBg }}>
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        <Stack direction="row" spacing={0} sx={{ mb: 4, flexWrap: 'wrap' }}>
          {TAB_ORDER.map((key) => (
            <TabButton key={key} active={active === key} onClick={() => setActive(key)}>
              {TABS[key].buttonLabel}
            </TabButton>
          ))}
        </Stack>

        <Grid container spacing={4} alignItems="flex-start">
          <Grid item xs={12} md={8} sx={{ minHeight: { md: 420 } }}>
            <Typography variant="h3" sx={{ color: BRAND.tabActiveBg, mb: 3 }}>
              {tab.heading}
            </Typography>
            <Typography variant="body1" sx={{ color: '#5f6b7a', fontSize: 18, mb: 3 }}>
              {tab.body}
            </Typography>
            <Button
              variant="contained"
              onClick={() => setDialogOpen(true)}
              sx={{ bgcolor: BRAND.ctaGold, color: '#1c1e2a', fontWeight: 700, '&:hover': { bgcolor: BRAND.ctaGoldHover } }}
            >
              {tab.ctaLabel}
            </Button>
          </Grid>
        </Grid>
      </Container>

      <CtaFormDialog open={dialogOpen} onClose={() => setDialogOpen(false)} title={tab.ctaLabel} />
    </Box>
  );
}
